import { ActivityType } from './lesson-upcoming-activity';
import { UserType } from '../pages/login';
import { IActivityCardItems, IActivityCard } from './activity-card';
import { IPreference } from '../../models/action/profile';
import { IPagedQuery } from './paginate';

export interface IAssignmentGradeProps {
    coursePageClassId?: string;
    activityId: string;
    activityCardItems?: Array<IActivityCardItems>;
    activityCard?: IActivityCard;
    coursePageclassInformation?: {
        courseName: string;
        programName: string;
        teacher: Array<any>;
        logoUrl: string;
        courseDescription: string;
        isWeekly: boolean | null;
        startDate: Date | null;
        endDate: Date | null;
    };
    assignmentGradeInformation?: IAssignmentGradeInformationModel;
    results?: Array<IAssignmentGradeStudentItem>;
    assignmentGradeSaveResult?: {
        userId: number;
        score: number;
        classId: string;
        activityId: string;
        status: string;
    };
    filters?: IPagedQuery;
    dispatch?: any;
    onClose?: (refresh: boolean) => void;
    modalIsOpen?: boolean;
    userPreferences?: Array<IPreference>;
    groupId?: string;
    isProjectSubActivity: boolean;
    bulkGradeOnChange?: any;
}

export const FilterInitialValues: IPagedQuery = {
    orderBy: '',
    query: '',
    page: 1,
    total: -1,
    skip: 0,
    take: 10
};

export interface IAssignmentGradeState {
    isReportModalOpen: boolean;
}

export interface IAssignmentGradeInformationModel {
    totalStudent: number;
    uploadedStudent: number;
    notUploadedStudent: number;
    notEvaluated: number;
    activityDescription: string;
    files: Array<IAssignmentGradeFiles>;
    activityId : string;
    isCommon: number;
    activityName: string;
    showPlagiarismControls: boolean;
}

export interface IAssignmentGradeFiles {
    fileId: string;
    fileName: string;
    fileSize: number;
    filePath: string;
    fileType: string;
}

export interface IAssignmentGradeStudentItem {
    // ALMS+ types
    userId: string | null;
    userFullName: string | null;
    lastUploadTime: string | null;
    uploadedAndTotalCount: string | null;
    userAvatar: string | null;
    downloadLink: null | {fileName: string, filePath: string};
    score: number | null;
    uploadChanceIsPassed: boolean;
    showPlagiarismControls: boolean;
    plagiarismRate: number;
    plagiarismRemoteId: string | null;
    plagiarismReportUrl: string | null;
    className: string | null;
}
